import get from 'lodash/get';
import {
  GET_GALLERY_VIDEO_SUCCESS,
  REMOVE_GALLERY_VIDEO,
  GET_GALLERY_RCI_TV_VIDEO_SUCCESS,
  GET_GALLERY_IMAGE_SUCCESS,
  REMOVE_GALLERY_IMAGE,
} from '../constant';
import { logErrorMessage } from './LogErrorMessage';
import store from '../../store/store';
import { getDataFromService } from '../../service';
import { RESORT_VIDEO_GALLERY, RESORT_IMAGES_URL } from '../constant/app.properties';


const {
  REACT_APP_SERVICE_URL,
} = window.weeksWebCloudConfig;

export const fetchVideoSuccess = data => ({
  type: GET_GALLERY_VIDEO_SUCCESS,
  payload: data,
});

export const getVideoDetails = resortId => async (dispatch) => {
  const {
    customerProfile,
    customerId,
  } = store.getState().CommonReducer;
  const url = `${REACT_APP_SERVICE_URL}${RESORT_VIDEO_GALLERY}`;
  try {
    const serviceResponse = await getDataFromService({
      url,
      method: 'POST',
      customerID: customerId,
      requestBody: {
        brand: 'RCI',
        flowType: 'ResortDirectory_RD_ICON',
        locale: get(customerProfile, 'locale', 'en_US'),
        resortCode: resortId,
      },
    });
    if (serviceResponse.status === 200) {
      dispatch(fetchVideoSuccess(serviceResponse.data));
    } else {
      console.error('RCI weeks error:', '[getVideoDetails] API failed with status:', serviceResponse.status, JSON.stringify({ url }));
      console.log('RCI weeks error:', '[getVideoDetails] API failed with status:', serviceResponse.status, JSON.stringify({ url }));
      dispatch(logErrorMessage(serviceResponse, 'getVideoDetails not successful'));
    }
  } catch (error) {
    console.error('RCI weeks error:', '[getVideoDetails] API failed:', JSON.stringify({ url }), error);
    console.log('RCI weeks error:', '[getVideoDetails] API failed:', JSON.stringify({ url }), error);
    dispatch(logErrorMessage(error, 'getVideoDetails not successful'));
  }
};

export const fetchImageSuccess = data => ({
  type: GET_GALLERY_IMAGE_SUCCESS,
  payload: data,
});

export const getImageDetails = resortId => async (dispatch) => {
  const { customerId } = store.getState().CommonReducer;
  const url = `${REACT_APP_SERVICE_URL}${RESORT_IMAGES_URL}/${decodeURIComponent(resortId).trim().toUpperCase()}/images`;
  try {
    const serviceResponse = await getDataFromService({
      url,
      method: 'GET',
      customerID: customerId,
    });
    if (serviceResponse.status === 200) {
      dispatch(fetchImageSuccess(serviceResponse.data[resortId]));
    } else {
      console.error('RCI weeks error:', '[getImageDetails] API failed with status:', serviceResponse.status, JSON.stringify({ url }));
      console.log('RCI weeks error:', '[getImageDetails] API failed with status:', serviceResponse.status, JSON.stringify({ url }));
      dispatch(logErrorMessage(serviceResponse, 'getImageDetails not successful'));
    }
  } catch (error) {
    console.error('RCI weeks error:', '[getImageDetails] API failed:', JSON.stringify({ url }), error);
    console.log('RCI weeks error:', '[getImageDetails] API failed:', JSON.stringify({ url }), error);
    dispatch(logErrorMessage(error, 'getImageDetails not successful'));
  }
};

export const fetchRciTvVideoSuccess = data => ({
  type: GET_GALLERY_RCI_TV_VIDEO_SUCCESS,
  payload: data,
});

export const getRciTvVideoDetails = resortId => async (dispatch) => {
  const {
    customerProfile,
    customerId,
  } = store.getState().CommonReducer;
  const url = `${REACT_APP_SERVICE_URL}${RESORT_VIDEO_GALLERY}`;
  try {
    const serviceResponse = await getDataFromService({
      url,
      method: 'POST',
      customerID: customerId,
      requestBody: {
        brand: 'RCI',
        flowType: 'ResortDirectory_RCITV_ICON',
        locale: get(customerProfile, 'locale', 'en_US'),
        resortCode: resortId,
      },
    });
    if (serviceResponse.status === 200) {
      dispatch(fetchRciTvVideoSuccess(serviceResponse.data));
    } else {
      console.error('RCI weeks error:', '[getRciTvVideoDetails] API failed with status:', serviceResponse.status, JSON.stringify({ url }));
      console.log('RCI weeks error:', '[getRciTvVideoDetails] API failed with status:', serviceResponse.status, JSON.stringify({ url }));
      dispatch(logErrorMessage(serviceResponse, 'getRciTvVideoDetails not successful'));
    }
  } catch (error) {
    console.error('RCI weeks error:', '[getRciTvVideoDetails] API failed:', JSON.stringify({ url }), error);
    console.log('RCI weeks error:', '[getRciTvVideoDetails] API failed:', JSON.stringify({ url }), error);
    dispatch(logErrorMessage(error, 'getRciTvVideoDetails not successful'));
  }
};

export const removeVideoDetails = () => async (dispatch) => {
  dispatch({
    type: REMOVE_GALLERY_VIDEO,
  });
};

export const removeImageDetails = () => async (dispatch) => {
  dispatch({
    type: REMOVE_GALLERY_IMAGE,
  });
};
